"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _context = require("../../context");

var _styled = require("../../styled");

var _styled2 = _interopRequireDefault(require("./styled"));

var _color = require("../../../../styles/helpers/color");
/* eslint-disable no-restricted-globals */


var Rgba = /*#__PURE__*/_react["default"].forwardRef(function (_props, ref) {
  var _ref = (0, _react.useContext)(_context.ColorPickerContext) || {},
      rgba = _ref.rgba,
      hsv = _ref.hsv,
      hex = _ref.hex,
      tabIndex = _ref.tabIndex,
      onChange = _ref.onChange;

  var firstRef = (0, _react.useRef)();
  var lastRef = (0, _react.useRef)();
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      focus: function focus() {
        firstRef.current.focus();
      },
      click: function click() {
        firstRef.current.click();
      },
      blur: function blur() {
        lastRef.current.blur();
      }
    };
  });

  var handleAlphaChange = function handleAlphaChange(event) {
    var value = parseInt(event.target.value, 10);
    var newApha = isNaN(value) ? 1 : Math.max(0, Math.min(value, 100)) / 100;
    rgba[3] = newApha;
    onChange({
      hex: hex,
      rgba: rgba,
      hsv: hsv
    });
  };

  var handleChange = function handleChange(index, event) {
    var value = parseInt(event.target.value, 10);

    if (isNaN(value)) {
      rgba[index] = 0;
    } else {
      rgba[index] = Math.max(0, Math.min(value, 255));
    }

    var rgbaColor = (0, _color.recomposeColor)({
      type: 'rgba',
      values: rgba
    });
    onChange({
      hex: (0, _color.rgbaToHex)(rgbaColor),
      rgba: rgba,
      hsv: (0, _color.decomposeColor)((0, _color.rgbToHsv)(rgbaColor)).values
    });
  }; // eslint-disable-next-line id-length


  var _rgba = (0, _slicedToArray2["default"])(rgba, 4),
      r = _rgba[0],
      g = _rgba[1],
      b = _rgba[2],
      a = _rgba[3];

  var alpha = Math.round(a * 100);
  return /*#__PURE__*/_react["default"].createElement(_styled.StyledFlexContainer, null, /*#__PURE__*/_react["default"].createElement(_styled2["default"], {
    type: "number",
    value: r,
    bottomHelpText: "R",
    onChange: function onChange(event) {
      return handleChange(0, event);
    },
    tabIndex: tabIndex,
    ref: firstRef
  }), /*#__PURE__*/_react["default"].createElement(_styled2["default"], {
    type: "number",
    value: g,
    bottomHelpText: "G",
    onChange: function onChange(event) {
      return handleChange(1, event);
    },
    tabIndex: tabIndex
  }), /*#__PURE__*/_react["default"].createElement(_styled2["default"], {
    type: "number",
    value: b,
    bottomHelpText: "B",
    onChange: function onChange(event) {
      return handleChange(2, event);
    },
    tabIndex: tabIndex
  }), /*#__PURE__*/_react["default"].createElement(_styled2["default"], {
    type: "number",
    value: alpha,
    bottomHelpText: "ALPHA",
    onChange: handleAlphaChange,
    tabIndex: tabIndex,
    ref: lastRef
  }));
});

var _default = Rgba;
exports["default"] = _default;